<div class="user-login-container">
  <form [formGroup]="signupForm" (submit)="onVendorLoginSubmit(signupForm)">
    <h4>Pandit Registration Form</h4>
    <div class="row white-box">
      <div class="col-md-6">
        <label>First name</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="first_name" matInput placeholder="Enter first name" required />
          <mat-error *ngIf="requiredValidation(formControls['first_name'])">First name is required.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <label>Last name</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="last_name" matInput placeholder="Enter last name" required />
          <mat-error *ngIf="requiredValidation(formControls['last_name'])">Last name is required.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <label>Email</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="email" matInput placeholder="Enter Email" required />
          <mat-error *ngIf="requiredValidation(formControls['email'])">Email is required</mat-error>
          <mat-error *ngIf="patternValidation(formControls['email'])">Enter valid email address</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <label>Zip Code</label>
        <mat-form-field appearance="outline">
          <input type="number" matInput placeholder="Choose zip code" (blur)="onBlur()"  formControlName="zip" required [matAutocomplete]="autoGroup">
          <mat-autocomplete #autoGroup="matAutocomplete">
            <mat-option *ngFor="let zipcode of zipcodeList" [value]="zipcode.text">
              {{zipcode.text}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="requiredValidation(formControls['zip'])">Zip code is required.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <label>Pandit Type</label>
        <mat-form-field appearance="outline">
          <mat-select required placeholder="Select type" required (selectionChange)="onChangePanditType($event)">
            <mat-option value="0">Individual</mat-option>
            <mat-option value="1">Associated with temple</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-6" *ngIf="isShowTempleNameField[0]">
        <label>Temples</label>
        <mat-form-field appearance="outline">
          <input type="text" matInput formControlName="temple_id" placeholder="Choose temple"
            [matAutocomplete]="autoGroup" [attr.required]="isShowTempleNameField[0]">
          <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)='onSelectTemple($event.option.value)'>
            <mat-option *ngFor="let temple of templeList" [value]="temple">
              {{temple?.name}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="requiredValidation(formControls['temple_id'])">Temple is required</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6" *ngIf="isShowTempleNameField[0]">
        <label>Temple Zip Code</label>
        <mat-form-field appearance="outline">
          <input type="text" formControlName="temple_zip" matInput placeholder="Enter temple zip code" readonly />
          <mat-error *ngIf="requiredValidation(formControls['temple_zip'])">
            Temple zip code is required.</mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <label>Password</label>
        <mat-form-field appearance="outline">
          <input #passwordRef type="password" formControlName="password" matInput placeholder="Enter Password"
            required />
            <mat-error *ngIf="requiredValidation(formControls['password'])">Password is required</mat-error>
        </mat-form-field>
        <password-strength-meter [password]="signupForm.get('password').value" minPasswordLength="6">
        </password-strength-meter>
      </div>

      <div class="col-md-6">
        <label>Confirm Password</label>
        <mat-form-field appearance="outline">
          <input type="password" formControlName="confirmPassword" matInput placeholder="Enter Confirm Password"
            required />
            <mat-error *ngIf="requiredValidation(formControls['confirmPassword'])">Confirm password is required</mat-error>
            <mat-error *ngIf="signupForm.controls['confirmPassword'].hasError('NoPassswordMatch')">
              Passwords does not match
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-12 MB-10 text-center">
        <button type="submit" mat-raised-button class="black-btn" [disabled]="!signupForm.valid"color="primary">
          Register
        </button>
      </div>
    </div>

    <div class="col-md-12 sign-up-link text-center">
      <span>Do you have an account? <a [routerLink]="loginUrl">Login</a></span>
    </div>
  </form>
</div>
